import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "name", "value"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-checkbox", { 'pb-x6': _ctx.showErrors }])
  }, [
    _createVNode(_component_Field, {
      modelValue: _ctx.internalValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalValue) = $event)),
      name: _ctx.name,
      rules: _ctx.fieldRules,
      "unchecked-value": false,
      type: "checkbox",
      value: _ctx.value
    }, {
      default: _withCtx(({ field, errorMessage }) => [
        _createElementVNode("input", _mergeProps({ id: _ctx.fieldId }, { ..._ctx.$attrs, ...field }, {
          type: "checkbox",
          name: _ctx.name,
          value: _ctx.value,
          class: [{ 'c-checkbox__field--error': !!errorMessage }, "c-checkbox__field"],
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.target.blur()))
        }), null, 16, _hoisted_1),
        _createElementVNode("label", {
          for: _ctx.fieldId,
          class: "c-checkbox__label"
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
          ])
        ], 8, _hoisted_2),
        (_ctx.showErrors)
          ? (_openBlock(), _createBlock(_component_InputErrorMessage, {
              key: 0,
              name: _ctx.name,
              class: "c-checkbox__errors"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "name", "rules", "value"])
  ], 2))
}